// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjects-moduleprojects__CFxYT";
export { _1 as "projects" }
